<div
  class="container-fluid"
  style="padding: 0px; max-height: 98vh"
  *ngIf="showChangePasswordMessage"
>
  <div class="login-text">
    <p>
      Your password has been successfully updated. You will be returned to the
      login page in 5 seconds.
    </p>
  </div>
</div>
